import React from 'react';
import {
	summary,
	way,
	fee,
	refundPolicy,
	mobileFee,
	mobileDeposit,
} from './data';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container} from '../../../Components/Atom';

const Summary = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '대회요강']} />
			<CardSection {...summary} />
			<CardSection {...fee} />
			<CardSection {...refundPolicy} />
			<CardSection {...way} />
			<CardSection {...mobileFee} />
			<CardSection {...mobileDeposit} />
		</Container>
	);
};

export default Summary;
